import { render, staticRenderFns } from "./OrderWatchlist.vue?vue&type=template&id=2c7e9c10&"
import script from "./OrderWatchlist.vue?vue&type=script&lang=js&"
export * from "./OrderWatchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports